import { render, staticRenderFns } from "./page-5.vue?vue&type=template&id=c56d07e2&scoped=true&"
import script from "./page-5.vue?vue&type=script&lang=js&"
export * from "./page-5.vue?vue&type=script&lang=js&"
import style0 from "./page-5.vue?vue&type=style&index=0&id=c56d07e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56d07e2",
  null
  
)

export default component.exports